import React from 'react';
import { AppBar, Toolbar, Typography, Drawer, List, ListItem, ListItemText, CssBaseline, Box, ListItemButton, Button } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const drawerWidth = 220;

const navItems = [
  { label: 'Users', path: '/users', adminOnly: true },
  { label: 'Owners', path: '/owners', adminOnly: true },
  { label: 'Accounts', path: '/accounts', adminOnly: true },
  { label: 'Transactions', path: '/transactions', adminOnly: true },
  { label: 'Secrets', path: '/secrets', adminOnly: true },
  { label: 'TWAP Wallet', path: '/twap', adminOnly: false },
  { label: 'Wallet Key Generator', path: '/wallet-key-generator', adminOnly: false },
];

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  const isAdmin = !!user?.admin;
  const visibleNavItems = navItems.filter((item) => isAdmin || !item.adminOnly);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            Custodian
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          {user && (
            <>
              <Typography variant="body2" sx={{ mr: 2 }}>
                <Link
                  to="/change-password"
                  style={{ color: 'inherit', textDecoration: 'underline', fontWeight: 500 }}
                >
                  {user.email}
                </Link>
              </Typography>
              <Button color="inherit" onClick={handleSignOut}>
                Sign out
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {visibleNavItems.map((item) => (
              <ListItem key={item.path} disablePadding>
                <ListItemButton
                  component={Link}
                  to={item.path}
                  selected={location.pathname.startsWith(item.path)}
                >
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
            {isAdmin && (
              <ListItem key="scheduled-payments" disablePadding>
                <ListItemButton
                  component={Link}
                  to="/scheduled-payments"
                  selected={location.pathname.startsWith('/scheduled-payments')}
                >
                  <ListItemText primary="Scheduled Payments" />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        </Box>
      </Drawer>
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
      >
        <Toolbar />
        {/* <Container maxWidth="lg">{children}</Container> */}
        <Box sx={{ width: '100%', height: '100%' }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default MainLayout; 